import BibliographyAuthoritySearch, {
  InputAuthoritySearchItem,
  defaultInputAuthoritySearchItem
} from './BibliographyAuthoritySearch.vue'

export {
  BibliographyAuthoritySearch,
  InputAuthoritySearchItem,
  defaultInputAuthoritySearchItem
}
